import { Box, Divider, Typography } from '@mui/material';
import { YearSegment } from '../../types/category';

interface YearSegmentDividerProps {
  yearSegment: YearSegment;
}

const YearSegmentDivider = ({ yearSegment }: YearSegmentDividerProps) => (
  <Box mt={3}>
    <Typography variant="h4" color={'gray'} sx={{ userSelect: 'none' }}>
      {
        {
          [YearSegment.WholeYear]: 'Celý rok',
          [YearSegment.FirstHalf]: '1. pololetí',
          [YearSegment.SecondHalf]: '2. pololetí',
        }[yearSegment]
      }
    </Typography>
    <Divider sx={{ height: 10 }} />
  </Box>
);

export default YearSegmentDivider;
